import "./index.css";
import "@lst/ui-components-vue/dist/style.css";
import { createBaseApplication, type RouteRecord, } from "@lst/ui-components-vue";
import { config as configurationsConfig } from "@/pai-configurations/config";
import { config as assetRegistryConfig } from "@/pai-asset-registry/config";
import { config as utilitiesConfig } from "@/utilities/config";
import { config as partnerRegistryConfig } from "@/pai-partnerplace/config";
import { registerAllMockHandlers } from "@/mockApiHandlers";

const activeExperimentalFeatures =
    import.meta.env.VITE_EXPERIMENTAL_FEATURES?.split(",") || [];
const routes = getRoutes();

// Determine if mock API should be enabled:
// - Global mock via VITE_MOCK_API environment variable
const enableMockGlobal = import.meta.env.VITE_MOCK_API === "true";
// Register mock API handlers if needed
await registerAllMockHandlers(enableMockGlobal);

createBaseApplication({
    appKey: "operations",
    icon: "speedometer",
    name: "Operations",
    color: "emerald",
    apiConfigs: {
        ...assetRegistryConfig.getApiConfig!(),
        ...configurationsConfig.getApiConfig!(),
        ...partnerRegistryConfig.getApiConfig!()
    },
    auth: {
        domain: import.meta.env.VITE_AUTH0_DOMAIN || "",
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || "",
        redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
        defaultAudience: import.meta.env.VITE_LST_AUTH_RESOURCE_SERVER,
        cacheLocation: "memory",
        scopes: [
            "openid",
            "profile",
            "email",
            "read:assets",
            "manage:assets",
            "change:asset-state",

            "manage:configuration-settings",
            "read:configuration-settings",
            "delete:configuration-settings",
            "create:configuration-settings",
            "update:configuration-settings",

            "read:partnerplace-api",
            "write:partnerplace-api",

            "upload:files",
            "read:files",
            "download:files",
            "delete:files",
            "manage:files"
        ],
        authorizationRule: {
            namespace: "https://lst-paf.com/user_authorization",
            allowedApplicationGroups: ["OPERATIONS"],
            allowedRoles: ["@lst/operations", "@lst/tech", "@lst/management"],
        },
        logoutUrl: import.meta.env.VITE_AUTH0_LOGOUT_URI,
        useMockAuth: import.meta.env.VITE_MOCK_AUTH === "true",
    },
    routes,
    activeExperimentalFeatures,
    enableMockGlobal: import.meta.env.VITE_MOCK_API === "true",
}).mount("#app");

function getRoutes() {
    return [
        {
            path: "/",
            redirect: {
                path: "/home",
                force: true,
            },
        },
        ...assetRegistryConfig.routes!,
        ...partnerRegistryConfig.routes!,
        ...configurationsConfig.routes!,
        ...utilitiesConfig.routes!,
    ] as RouteRecord[];
}
